<template>
  <div>
    <div>
      <div>
        <b-card-group deck>
          <b-card
            bg-variant="dark"
            header="Sessions"
            text-variant="white"
            class="text-center"
          >
            <b-card-text>{{ tracksSessions.length }}</b-card-text>
          </b-card>

          <b-card
            bg-variant="dark"
            header="Avg. Time"
            text-variant="white"
            class="text-center"
          >
            <b-card-text>10m</b-card-text>
          </b-card>

          <b-card
            bg-variant="dark"
            header="Return Visits"
            text-variant="white"
            class="text-center"
          >
            <b-card-text>20%</b-card-text>
          </b-card>
        </b-card-group>
      </div>
      <b-row>
        <b-col>
          <p>All Tracks: {{ tracksAll.length }}</p>
          <p>
            Session with only Open/Close:{{
              tracksSessionsWithOnlyOpenClose.length
            }}
          </p>
          <p v-for="(size, i) in 20">
            Sessions w/Activity > {{ size }}:
            {{
              tracksSessionsWithActivityWithOperatorNnumber(">", size).length
            }}
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//ipAddress

export default {
  name: "BaseActivity",
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.getToolAppTracksForUser();
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      appTracks: "tools/appTracks"
    }),
    allSessions() {
      return this.appTracks ? this.appTracks.length : 0;
    },
    tracksSessions() {
      let result = [];
      if (Array.isArray(this.appTracks)) {
        result = this.appTracks;
      }
      return result;
    },
    tracksSessionsWithOnlyOpenClose() {
      //Can do more of a check for open close
      let tracksSessions = [];
      if (Array.isArray(this.appTracks)) {
        this.appTracks.forEach(session => {
          if (session.tracks && session.tracks.length === 3) {
            tracksSessions.push(session);
          }
        });
      }
      return tracksSessions;
    },
    tracksAll() {
      let tracksAll = [];
      if (Array.isArray(this.appTracks)) {
        this.appTracks.forEach(session => {
          if (session.tracks) {
            tracksAll = [...tracksAll, ...session.tracks];
          }
        });
      }
      return tracksAll;
    }
  },
  methods: {
    getToolAppTracksForUser() {
      if (this.resource) {
        const payload = {
          user: this.user,
          toolId: this.resource.toolId
        };
        this.$store
          .dispatch("tools/getToolAppTracksForUser", payload)
          .then(tracks => {
            console.log(tracks);
          });
      }
    },
    tracksSessionsWithActivityWithOperatorNnumber(op, num) {
      //Can do more of a check for open close
      let tracksSessions = [];
      if (Array.isArray(this.appTracks)) {
        this.appTracks.forEach(session => {
          let push = false;
          if (session.tracks) {
            push = false;
            if (op === ">" && session.tracks.length > num) push = true;
            if (op === "<" && session.tracks.length < num) push = true;
            if (op === "=" && session.tracks.length === num) push = true;
            if (push) {
              tracksSessions.push(session);
            }
          }
        });
      }
      return tracksSessions;
    }
  }
};
</script>

<style lang="scss" scoped></style>
